import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";
import configs from "config";
import { BankRO, ISuspension, ResolveData, ResolvePayload } from "interfaces";
import ls from "utils/secureStorage";

// Define a service using a base URL and expected endpoints
export const baseApi = createApi({
  reducerPath: "base",
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: configs.BASE_URL,
    prepareHeaders: (headers, _) => {
      const accessKey = ls.get(configs.ACCESS_KEY);
      const _auth = ls.get(configs.AUTH_TOKEN_KEY);
      const auth = _auth ? JSON.parse(_auth) : undefined;

      let authTokenAndAccessKey = [];
      if (auth?.token) authTokenAndAccessKey.push(auth?.token);
      if (accessKey) authTokenAndAccessKey.push(accessKey);

      if (authTokenAndAccessKey) headers.set("Authorization", authTokenAndAccessKey.join("::,"));

      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    removeAuthSuspension: builder.mutation({
      query: ({ email, token }: ISuspension) => ({
        url: `/widget/reset-otp`,
        method: "POST",
        body: {
          email,
          token,
        },
      }),
      transformResponse: (res: any) => res,
    }),

    getBanks: builder.query({
      query: (country: string) => `/widget/banks?country=${country}`,
      transformResponse: (res: AxiosResponse<BankRO>) => res?.data,
    }),

    getOtcApiKey: builder.query({
      query: () => `/widget/otc-access-key`,
      transformResponse: (res: AxiosResponse<Record<"accessKey", string>>) => res?.data,
    }),

    resolveBankAcct: builder.mutation({
      query: ({ bankAccountNumber, bankCode }: ResolvePayload) => ({
        url: `/widget/fiatAccount/resolve`,
        method: "POST",
        body: {
          bankAccountNumber,
          bankCode,
        },
      }),
      transformResponse: (res: AxiosResponse<ResolveData>) => res.data,
    }),

    getWidgetAccountName: builder.query({
      query: () => `/widget/account-name`,
      transformResponse: (res: AxiosResponse) => res?.data,
    }),

    addWidgetAccountName: builder.mutation({
      query: (accountName: string) => ({
        url: `/widget/account-name`,
        method: "POST",
        body: {
          accountName,
        },
      }),
      transformResponse: (res: any) => res,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useRemoveAuthSuspensionMutation,
  useGetBanksQuery,
  useGetOtcApiKeyQuery,
  useResolveBankAcctMutation,
  useAddWidgetAccountNameMutation,
  useGetWidgetAccountNameQuery,
} = baseApi;

export default baseApi;
